const code = 'epl';
const codeAPI = 'epl';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};